export default "__VITE_ASSET__BIdIr$bc__"